"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInvoiceIssuerAuthorizationsDto = exports.UpdateInvoiceIssuerAuthorizationDto = exports.CreateInvoiceIssuerAuthorizationDto = void 0;
const class_validator_1 = require("class-validator");
const cursor_pagination_1 = require("../cursor-pagination");
class CreateInvoiceIssuerAuthorizationDto {
    issuerUserId;
    validFrom;
    validUntil;
    agreementReference;
    acceptanceProcedure;
}
exports.CreateInvoiceIssuerAuthorizationDto = CreateInvoiceIssuerAuthorizationDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateInvoiceIssuerAuthorizationDto.prototype, "issuerUserId", void 0);
__decorate([
    (0, class_validator_1.IsISO8601)({ strict: true }),
    __metadata("design:type", String)
], CreateInvoiceIssuerAuthorizationDto.prototype, "validFrom", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsISO8601)({ strict: true }),
    __metadata("design:type", String)
], CreateInvoiceIssuerAuthorizationDto.prototype, "validUntil", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateInvoiceIssuerAuthorizationDto.prototype, "agreementReference", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateInvoiceIssuerAuthorizationDto.prototype, "acceptanceProcedure", void 0);
class UpdateInvoiceIssuerAuthorizationDto {
    validUntil;
    revoked;
    acceptanceProcedure;
}
exports.UpdateInvoiceIssuerAuthorizationDto = UpdateInvoiceIssuerAuthorizationDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsISO8601)({ strict: true }),
    __metadata("design:type", String)
], UpdateInvoiceIssuerAuthorizationDto.prototype, "validUntil", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], UpdateInvoiceIssuerAuthorizationDto.prototype, "revoked", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], UpdateInvoiceIssuerAuthorizationDto.prototype, "acceptanceProcedure", void 0);
class SearchInvoiceIssuerAuthorizationsDto extends cursor_pagination_1.CursorPaginationOptions {
    issuerUserId;
    activeOn;
}
exports.SearchInvoiceIssuerAuthorizationsDto = SearchInvoiceIssuerAuthorizationsDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SearchInvoiceIssuerAuthorizationsDto.prototype, "issuerUserId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsISO8601)({ strict: true }),
    __metadata("design:type", String)
], SearchInvoiceIssuerAuthorizationsDto.prototype, "activeOn", void 0);
